var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('vx-card',{staticClass:"overflow-hidden mb-base",attrs:{"title":"Statistiques globales","collapse-action":""}},[_c('template',{slot:"no-body"},[_c('stats-summary')],1)],2),_c('vx-card',{attrs:{"title":"Statistiques","collapse-action":""}},[_c('template',{slot:"no-body"},[_c('stats-details')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }